import { useState } from 'react';
import CustomerMessageBox from './CustomerMessageBox.jsx';
import { useFeatureOff } from '../../../hooks/useEnvironment';

// Every Quote Ready click opens this (spec docs/archive/202610/specs_20261013_offer_message.md). The
// message is optional: its own paragraph in the Quote Ready email, after the thank-you
// line. "Continue" hands it, empty or not, to the normal Quote Ready flow, so the pair,
// buying-rule and shortfall gates still run after it. With no email address a message
// could never be delivered, so Continue is off while the box has text.
export default function QuoteReadyMessageDialog({ preview, toEmail, onCancel, onConfirm }) {
    const [message, setMessage] = useState('');
    // On staging the email is skipped server-side, but the stage change must still run,
    // so Continue stays enabled and the note says what happens instead.
    const emailOff = useFeatureOff('email');
    return (
        <div className="modal-overlay">
            <div className="modal-content" style={{ width: '100%', maxWidth: 640 }} onClick={e => e.stopPropagation()}>
                <div className="modal-header"><h2>Quote Ready</h2><button className="modal-close" onClick={onCancel}>&times;</button></div>
                <div className="modal-body-scroll">
                    {emailOff && (
                        <p><span className="badge badge-neutral">Off on staging: {emailOff}. The quote still moves to Quote Sent.</span></p>
                    )}
                    <p>A message is optional. The customer reads it before they open the quote, so it must make sense without the price.</p>
                    {!toEmail && (
                        <div className="qa-error qa-banner" role="alert">
                            No email address was found for this customer, so no Quote Ready email can be sent and a message cannot be added.
                        </div>
                    )}
                    <CustomerMessageBox id="quote-ready-message" value={message} onChange={setMessage}
                        preview={preview} toEmail={toEmail} testId="quote-ready-email-preview"
                        placeholder="Its own paragraph after the thank-you line. Write full sentences, as 'we'." />
                </div>
                <div className="modal-footer" style={{ padding: 'var(--space-4)' }}>
                    <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
                    <button className="btn btn-quote-ready" onClick={() => onConfirm(message.trim())} disabled={!!message.trim() && !toEmail}>Continue</button>
                </div>
            </div>
        </div>
    );
}
